module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot54-16b90236dd52751c30d1ec3a9a5b5717.jpg";